export default __webpack_public_path__ + "static/media/banner-img.f1783692.png";